<template>
  <v-data-table
    :loading="loading"
    :headers="headers"
    :items="data"
    sort-by="value"
    hide-default-footer
    hide-default-header
    dense
    :items-per-page="100"
    :mobile-breakpoint="0"
  >
    <template v-slot:item.product="{ item }">
      <span class="font-capitalize">{{ getProductName(item) }}</span>
    </template>
    <template v-slot:item.value="{ item }">
      <v-row no-gutters dense justify="end">
        <v-chip
          class="my-1"
          label
          small
          :color="
            item.value < 0 ? '#E5737355' : item.value > 0 ? '#66BB6A55' : ''
          "
        >
          {{ (Math.abs(item.value) * 100) | round2 }} %</v-chip
        >
      </v-row>
    </template>
  </v-data-table>
</template>

<script>
import { mapGetters } from "vuex";
import { api } from "@/api";
export default {
  name: "CorrectionValueGrid",
  computed: {
    ...mapGetters(["getProducts"])
  },
  mounted() {
    this.getData();
  },
  data() {
    return {
      loading: true,
      headers: [{ value: "product", sortable: false }, { value: "value" }],
      data: []
    };
  },
  methods: {
    async getData() {
      try {
        this.loading = true;
        const res = await api.getInventoryCorrectionValues({ recent: true });
        this.data = res.filter(x => x.value !== 0);
      } finally {
        this.loading = false;
      }
    },
    getProductName(item) {
      const p = this.getProducts.find(x => x.id === item.fk_product);
      if (p) {
        return p.nom;
      }
    }
  }
};
</script>

<style></style>
